import { itApiFetch } from "../../services/itApi";

function buildQuery(params = {}) {
	const searchParams = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		if (value !== undefined && value !== null && value !== "") {
			searchParams.append(key, String(value));
		}
	});
	const query = searchParams.toString();
	return query ? `?${query}` : "";
}

async function parseJsonResponse(response, fallbackMessage) {
	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || fallbackMessage);
	}
	return payload;
}

export async function getPortalRequests(filters = {}) {
	const response = await itApiFetch(`/api/it/portal-requests${buildQuery(filters)}`);
	const payload = await parseJsonResponse(response, "Failed to fetch portal requests");
	return Array.isArray(payload.portal_requests) ? payload.portal_requests : [];
}

export async function convertPortalRequest(portalRequestId) {
	const response = await itApiFetch(`/api/it/portal-requests/${portalRequestId}/convert`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({}),
	});
	return parseJsonResponse(response, "Failed to create incident");
}

export async function updatePortalRequestStatus(portalRequestId, status) {
	const response = await itApiFetch(`/api/it/portal-requests/${portalRequestId}`, {
		method: "PATCH",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ status }),
	});
	const payload = await parseJsonResponse(response, "Failed to update portal request");
	return payload.portal_request;
}